export default __webpack_public_path__ + "static/media/br_ad_banner.9aa0e6cc.jpg";